import apiClient from "./apiClient";

export interface Observation {
  id: number;
  observationId: number;
  observation: string;
}

export const addObservation = async (fromageId: number, observation: string): Promise<Observation | null> => {
  try {
    const response = await apiClient.post(`/fromages/${fromageId}/observation`, {
      observation,
    });
    return response.data;
  } catch (error) {
    // console.error("Failed to add observation:", error);
    return null;
  }
};

export const deleteObservation = async (fromageId: number, observationId: number): Promise<boolean> => {
  try {
    await apiClient.delete(`/fromages/${fromageId}/observation/${observationId}`);
    return true;
  } catch (error) {
    // console.error("Failed to delete observation:", error);
    return false;
  }
};